import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { combineValidators, isRequired } from 'revalidate';
import { reduxForm, Field } from 'redux-form';
import { loginAuth } from './redux/authApi';
import LogoPicture from '../../pictures/logo.png';
import { SCHOOL_NAME, SKOOLAS_ACADEMIK_URL, DEMO } from '../common/data/siteConfig';
import LoginTextInput from '../common/form/LoginTextInput';
import Icon from '@mdi/react';
import { mdiSchool, mdiWeb, mdiLogin, mdiAlphaSCircle } from '@mdi/js';
import ThemeTogggle from '../main/ThemeToggle';

function mapState(state) {
  return {
    auth: state.auth,
    loading: state.async.loading,
  };
}

const actions = {
  loginAuth,
};

const validate = combineValidators({
  username: isRequired({ message: 'Username is required' }),
  password: isRequired({ message: 'Password is required' }),
});

function Login(props) {
  const { loginAuth, handleSubmit, auth, error, loading } = props;

  const handleLogin = async (authData) => {
    await loginAuth(authData);
  };

  if (auth && auth.isAuth) return <Redirect to='/dashboard' />;

  return (
    <>
      <section
        className='hero is-fullheight gradient-login'
        style={{ marginTop: -52 }}
      >
        <div className='hero-body' style={{ position: 'relative' }}>
          <div
            style={{
              position: 'absolute',
              top: 12,
              right: 12,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <ThemeTogggle
              width={120}
              text={{ dark: 'Dark Mode', light: 'Light Mode' }}
              className='has-background-dark has-text-info'
            />
          </div>
          <div className='container'>
            <div className='columns is-centered is gapless'>
              <div className='column is-6-tablet is-6-desktop is-5-widescreen'>
                <div className='box'>
                  <div className='columns'>
                    <div className='column is-4-tablet is-3-desktop custom-background-purple'>
                      <div
                        className='flex flex-column justify-center'
                        style={{ height: '100%' }}
                      >
                        <div className='menu-login-icon has-text-white'>
                          <div
                            onClick={() =>
                              window.open(SKOOLAS_ACADEMIK_URL, '_blank')
                            }
                            className='flex flex-column justify-center align-center my-1'
                          >
                            <div
                              className='flex flex-column justify-center align-center hand-pointer hover-login-icon'
                              style={{ height: 90, width: 90 }}
                            >
                              <span className='icon is-large'>
                                <Icon path={mdiSchool} size={1.5} />
                              </span>
                              Akademik
                            </div>
                          </div>
                          <div className='flex flex-column justify-center align-center my-1'>
                            <div
                              className='flex flex-column justify-center align-center hand-pointer active-login-icon hover-login-icon'
                              style={{ height: 90, width: 90 }}
                            >
                              <span className='icon is-large'>
                                <Icon path={mdiWeb} size={1.5} />
                              </span>
                              Portal
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='column'>
                      <div className='media'>
                        <div className='media-content'>
                          <div className='content'>
                            <div className='has-text-centered mb-5'>
                              <div className='flex flex-column justify-center align-center'>
                                <div
                                  style={{
                                    backgroundColor: 'var(--logo-bg)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 140,
                                    height: 140,
                                  }}
                                >
                                  {DEMO ? (
                                    <Icon
                                      path={mdiAlphaSCircle}
                                      size={8}
                                      color='var(--bg-side-menu)'
                                    />
                                  ) : (
                                    <img
                                      alt='profile-pic'
                                      src={LogoPicture}
                                      style={{
                                        width: 55,
                                        height: 'auto',
                                      }}
                                    />
                                  )}
                                </div>
                                <p className='mt-1'>
                                  <span
                                    className='has-text-weight-bold is-size-5'
                                    style={{ color: 'var(--label' }}
                                  >
                                    {DEMO
                                      ? 'Selamat Datang di Portal Sekolah'
                                      : SCHOOL_NAME}
                                  </span>
                                  <br />
                                  <span className='has-text-info has-text-weight-bold is-size-6'>
                                    Admin Portal
                                  </span>
                                </p>
                              </div>
                            </div>
                            <form
                              onSubmit={handleSubmit(handleLogin)}
                              autoComplete='off'
                            >
                              <Field
                                name='username'
                                type='text'
                                component={LoginTextInput}
                                placeholder='Username'
                                autoComplete='new-password'
                                label='Username'
                                icon='account'
                              />
                              <Field
                                name='password'
                                type='password'
                                autoComplete='new-password'
                                component={LoginTextInput}
                                placeholder='Password'
                                label='Password'
                                icon='lock'
                              />
                              <div
                                className='field has-text-centered'
                                style={{ marginTop: 25 }}
                              >
                                {error && (
                                  <p className='help is-danger'>{error}</p>
                                )}
                                <button
                                  disabled={loading}
                                  type='submit'
                                  style={{ marginRight: 10 }}
                                  className={`button is-info is-small is-rounded${
                                    loading ? ' is-loading' : ''
                                  }`}
                                >
                                  <span className='icon is-small mr-1'>
                                    <Icon path={mdiLogin} size={0.5} />
                                  </span>
                                  Login
                                </button>
                              </div>
                            </form>
                            <div className='mt-5'></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p
          className='has-text-centered is-size-7 mb-3'
          style={{ marginTop: -14, color: 'var(--text)' }}
        >
          Copyright © {new Date().getFullYear()} Skoolas by{' '}
          <span className='has-text-weight-semibold'>Shaktavisi</span>
        </p>
      </section>
    </>
  );
}

export default withRouter(
  connect(mapState, actions)(reduxForm({ form: 'formLogin', validate })(Login)),
);
